import { SelectTemporada } from "@/helpers/SelectTemporada";
import { useConfigContext } from "@/state/configContext";
import { createFileRoute, Link, useRouter } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/config/")({
  component: RouteComponent,
});

function RouteComponent() {
  const config = useConfigContext();
  const router = useRouter();

  return (
    <>
      <div>
        Temporada:{" "}
        <SelectTemporada
          temporadas={Object.values(config.temporadas)}
          value={0}
          onChange={(id) =>
            router.navigate({ to: "/admin/config/temporada", search: { id } })
          }
        />
      </div>
      <div>
        <Link to="/admin/config/personal">Personal</Link>
      </div>
    </>
  );
}
